module.exports = __webpack_public_path__ + "static/media/artist_10.18739ba1.png";